module.exports = __webpack_public_path__ + "static/img/1.dabb6ab7.png";